export const PRIVACY_POLICIES = {
  "scanner-pronto-pdf": {
    lastUpdated: "2025-12-23",
    sections: [
      {
        title: "1) WHO WE ARE",
        paragraphs: [
          "Scanner Pronto PDF is developed and maintained by Huolong Apps (“we”, “our”, “us”).",
        ],
      },
      {
        title: "2) SUMMARY (IN PLAIN ENGLISH)",
        list: [
          "Your scans and generated PDFs are processed and stored on your device.",
          "No account is required to use the app.",
          "We do not upload your documents to our servers by default.",
          "If you share/export a file to another app (email, cloud, messaging), that third party handles the file under their own policy.",
        ],
      },
      {
        title: "3) DATA WE PROCESS",
        paragraphs: [
          "The app may process the following data to provide its core functionality:",
        ],
        list: [
          "Scanned images and documents (captured via your camera).",
          "Generated files (PDFs/images) that you choose to save.",
          "Device-level file metadata (name, created date, storage location) needed to manage files in-app.",
        ],
        footnote:
          "We do not require personal details (name, phone, address, etc.) to use the app.",
      },
      {
        title: "4) WHAT WE DO NOT DO",
        list: [
          "We do not sell your data.",
          "We do not access your contacts.",
          "We do not read your messages.",
          "We do not upload your scanned content to our servers by default.",
        ],
        footnote:
          "If future versions add online features (cloud sync, analytics, crash reports, ads, payments), this policy will be updated accordingly.",
      },
      {
        title: "5) HOW WE USE THE DATA",
        paragraphs: [
          "We use the processed data strictly to provide the app features, such as:",
        ],
        list: [
          "Capturing scans using the camera.",
          "Generating PDFs from scanned pages.",
          "Saving, listing, renaming, and deleting your files.",
          "Sharing/exporting files when you request it.",
        ],
      },
      {
        title: "6) STORAGE AND RETENTION",
        paragraphs: [
          "Your scans and generated documents are stored locally on your device.",
        ],
        list: [
          "You can delete documents from within the app (when available) or via your device file manager/gallery.",
          "Uninstalling the app may remove locally stored app data, depending on device settings and Android version.",
        ],
      },
      {
        title: "7) SHARING AND THIRD PARTIES",
        paragraphs: [
          "The app uses the Android system share sheet to let you share/export files. When you share a file:",
        ],
        list: [
          "The receiving app/service will process it under their own privacy policy.",
          "We do not control what third parties do after you share the file.",
        ],
      },
      {
        title: "8) APP PERMISSIONS",
        paragraphs: ["Depending on the features you use, the app may request:"],
        list: [
          "Camera: to capture document images for scanning.",
          "Photos/Media/Files (Storage): to save scans/PDFs and manage exported documents.",
        ],
        footnote:
          "If you deny a permission, some features may not work (for example, scanning requires camera access).",
      },
      {
        title: "9) SECURITY",
        paragraphs: [
          "We take reasonable measures to keep your data safe within the app. However, no method of device storage is 100% secure. Keep your device protected (PIN/biometrics) and avoid sharing sensitive documents with unknown third parties.",
        ],
      },
      {
        title: "10) CHILDREN’S PRIVACY",
        paragraphs: [
          "The app is not directed to children under 13, and we do not knowingly collect personal information from children.",
        ],
      },
      {
        title: "11) CHANGES TO THIS POLICY",
        paragraphs: [
          "We may update this policy from time to time. When we do, we will update the “Last updated” date on this page.",
        ],
      },
      {
        title: "12) CONTACT",
        paragraphs: [
          "If you have questions about this Privacy Policy, contact:",
          "vitor.diamantino@icloud.com",
        ],
        footnote:
          "If you email us, we will receive your email address and the information you include, and we will use it only to respond and provide support.",
      },
    ],
  },
  "Qr Code Scanner": {
    lastUpdated: "2025-12-23",
    sections: [
      {
        title: "1) WHO WE ARE",
        paragraphs: [
          "Scanner Pronto PDF is developed and maintained by Huolong Apps (“we”, “our”, “us”).",
        ],
      },
      {
        title: "2) SUMMARY (IN PLAIN ENGLISH)",
        list: [
          "Your scans and generated PDFs are processed and stored on your device.",
          "No account is required to use the app.",
          "We do not upload your documents to our servers by default.",
          "If you share/export a file to another app (email, cloud, messaging), that third party handles the file under their own policy.",
        ],
      },
      {
        title: "3) DATA WE PROCESS",
        paragraphs: [
          "The app may process the following data to provide its core functionality:",
        ],
        list: [
          "Scanned images and documents (captured via your camera).",
          "Generated files (PDFs/images) that you choose to save.",
          "Device-level file metadata (name, created date, storage location) needed to manage files in-app.",
        ],
        footnote:
          "We do not require personal details (name, phone, address, etc.) to use the app.",
      },
      {
        title: "4) WHAT WE DO NOT DO",
        list: [
          "We do not sell your data.",
          "We do not access your contacts.",
          "We do not read your messages.",
          "We do not upload your scanned content to our servers by default.",
        ],
        footnote:
          "If future versions add online features (cloud sync, analytics, crash reports, ads, payments), this policy will be updated accordingly.",
      },
      {
        title: "5) HOW WE USE THE DATA",
        paragraphs: [
          "We use the processed data strictly to provide the app features, such as:",
        ],
        list: [
          "Capturing scans using the camera.",
          "Generating PDFs from scanned pages.",
          "Saving, listing, renaming, and deleting your files.",
          "Sharing/exporting files when you request it.",
        ],
      },
      {
        title: "6) STORAGE AND RETENTION",
        paragraphs: [
          "Your scans and generated documents are stored locally on your device.",
        ],
        list: [
          "You can delete documents from within the app (when available) or via your device file manager/gallery.",
          "Uninstalling the app may remove locally stored app data, depending on device settings and Android version.",
        ],
      },
      {
        title: "7) SHARING AND THIRD PARTIES",
        paragraphs: [
          "The app uses the Android system share sheet to let you share/export files. When you share a file:",
        ],
        list: [
          "The receiving app/service will process it under their own privacy policy.",
          "We do not control what third parties do after you share the file.",
        ],
      },
      {
        title: "8) APP PERMISSIONS",
        paragraphs: ["Depending on the features you use, the app may request:"],
        list: [
          "Camera: to capture document images for scanning.",
          "Photos/Media/Files (Storage): to save scans/PDFs and manage exported documents.",
        ],
        footnote:
          "If you deny a permission, some features may not work (for example, scanning requires camera access).",
      },
      {
        title: "9) SECURITY",
        paragraphs: [
          "We take reasonable measures to keep your data safe within the app. However, no method of device storage is 100% secure. Keep your device protected (PIN/biometrics) and avoid sharing sensitive documents with unknown third parties.",
        ],
      },
      {
        title: "10) CHILDREN’S PRIVACY",
        paragraphs: [
          "The app is not directed to children under 13, and we do not knowingly collect personal information from children.",
        ],
      },
      {
        title: "11) CHANGES TO THIS POLICY",
        paragraphs: [
          "We may update this policy from time to time. When we do, we will update the “Last updated” date on this page.",
        ],
      },
      {
        title: "12) CONTACT",
        paragraphs: [
          "If you have questions about this Privacy Policy, contact:",
          "vitor.diamantino@icloud.com",
        ],
        footnote:
          "If you email us, we will receive your email address and the information you include, and we will use it only to respond and provide support.",
      },
    ],
  },
};
